import { render, staticRenderFns } from "./FormFconttitrecreate.vue?vue&type=template&id=73145401&"
import script from "./FormFconttitrecreate.vue?vue&type=script&lang=js&"
export * from "./FormFconttitrecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports